import { Route } from '@angular/router';
import { URI_PARAMS } from '../../shared/uri-params';

const routes: Array<Route> = [
  {
    path: '',
    loadComponent: () =>
      import('./channels/channels.component').then(
        (mod) => mod.ChannelsComponent,
      ),
    loadChildren: () => [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./channels-overview/channels-overview.component').then(
            (mod) => {
              return mod.ChannelsOverviewComponent;
            },
          ),
      },
      {
        path: `:${URI_PARAMS.channelSlug}`,
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./channels-channel/channels-channel.component').then(
                (mod) => mod.ChannelsChannelComponent,
              ),
          },
        ],
      },
      {
        path: `channel/:${URI_PARAMS.sourceId}`,
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./channels-channel/channels-channel.component').then(
                (mod) => mod.ChannelsChannelComponent,
              ),
          },
        ],
      },
      {
        path: `channel`,
        redirectTo: '../',
      },
    ],
  },
];

export default routes;
